<div class="assessment-console m-auto bg-white rounded shadow-sm-darker">
  <div class="tab-btns-wrap d-flex flex-column flex-sm-row">
    <button class="tab-btn border-0 px-1 py-3 p-sm-0" (click)="viewfilter(FILTER_ALL, $event)"
      [ngClass]="{'tab-btn--active': filter === FILTER_ALL}"><span class="mr-2">All Assessments</span>
      <span class="badge badge-success">{{assessmentList.length}}</span>
    </button>
    <button class="tab-btn border-0 px-1 py-3 p-sm-0" (click)="viewfilter(FILTER_TIMED, $event)"
      [ngClass]="{'tab-btn--active': filter === FILTER_TIMED}"><span class="mr-2">Timed Assessments?</span>
      <span class="badge badge-warning ">{{timedCount}}</span>
    </button>
  </div>
  <div class="p-4">

    <div class="row">
      <div class="col-sm-5">
       <label>Lesson:</label>
        <select class="p-2 m-1" (change)="filterByLesson(FilterByLessonText)"
          [(ngModel)]="FilterByLessonText"  name="FilterByLessonText">
          <option *ngFor="let action of courseFilterActions">
            {{action.displaytext}}
          </option>
        </select>
      </div>
      <div *ngIf="isBatched">
       <label>Batch:</label>
        <select class="p-2 m-1" (change)="sortByBatch(FilterByBatchText)"
          [(ngModel)]="FilterByBatchText" name="FilterByBatchText">
          <option *ngFor="let batch of moduleBatches" [ngValue]="batch.id">
            {{batch.name}}
          </option>
        </select>
      </div>
    </div>
    <p *ngIf="filteredAssessmentList.length < 1" class="text-sm text-center font-italic mb-0">There Are No Assessments
      Available In This Filter</p>
    <ul class="list-group list-group-flush">
      <li class="list-group-item px-0" *ngFor="let assessment of filteredAssessmentList">
        <button *ngIf="!assessment.istimed"
          (click)="openAssessment(assessment.id, assessment.classid,assessment.batchid)"
          class="d-block w-100 group-link p-0 m-0 border-0 bg-transparent text-left">
          <h3 class="text-sm font-weight-700 text-primary-darker mb-0">{{assessment.coursetitle}}</h3>
          <h3 class="text-sm font-weight-500 text-primary-darker mb-0">{{assessment.name}}</h3>
          <p class="text-xs m-0">
            <span class="font-weight-500">Start: </span><time>{{assessment.starttime}}</time>
            <br>
            <span class="font-weight-500">Due: </span><time>{{assessment.duedate}}</time>
            <br>
          </p>
          <div class="mt-2 text-xs">
            <span *ngIf="!assessment.optional" class="mt-2 mr-2 badge badge-lg badge-info">Mandatory</span>
            <span *ngIf="assessment.optional" class="badge badge-lg badge-info">Optional</span>
          </div>
        </button>
        <button *ngIf="assessment.istimed"
          (click)="openAssessment(assessment.id, assessment.classid,assessment.batchid)"
          class="d-block w-100 group-link p-0 m-0 border-0 bg-transparent text-left">
          <h3 class="text-sm font-weight-700 text-primary-darker mb-0">{{assessment.coursetitle}}</h3>
          <h3 class="text-sm font-weight-500 text-primary-darker mb-0">{{assessment.name}}</h3>
          <p class="text-xs m-0">
            <span class="font-weight-500">Start: </span><time>{{assessment.starttime}}</time>
            <br>
            <span class="font-weight-500">Due: </span><time>{{assessment.duedate}}</time>
            <br>
            <span class="font-weight-500">Duration: </span>{{assessment.duration}} {{assessment.duration == 1 ? "minute"
            : "minutes"}}
            <br />
          </p>
          <div class="mt-2 text-xs">
            <span class="badge badge-lg badge-info mr-2">Timed Assessment</span>
            <span *ngIf="!assessment.optional" class="mt-2 mr-2 badge badge-lg badge-info">Mandatory</span>
            <span *ngIf="assessment.optional" class="badge badge-lg badge-info">Optional</span>
          </div>
        </button>
      </li>
    </ul>
  </div>
</div>